import { Component, type ReactNode } from 'react';
import ServerError from '../../user/pages/ServerError';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

/**
 * エラーバウンダリーコンポーネント
 * Reactコンポーネントツリー内で発生したエラーをキャッチし、500エラーページを表示
 */
class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // エラーをコンソールに出力（開発環境）
    if (import.meta.env.DEV) {
      console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
    
    // 本番環境ではエラートラッキングサービスに送信（将来実装）
    // TODO: 自作エラートラッキングツールに送信
  }

  render() {
    if (this.state.hasError) {
      // エラーページを表示
      return <ServerError />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

